import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.transits) {
            this.props.requireState();
        }

        this.props.trackEvent([
            'Planet Tracker',
            `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
            'Planet Tracker',
        ]);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.transits != this.props.transits) {
            return true;
        }

        return false;
    }

    render({ transits }) {
        if (transits) {
            return (
                <planet-tracker>
                    <h2 className='has-margin-20-bottom has-margin-30-top-mobile has-weight-400'>
                        Planet Tracker
                    </h2>
                    <div className='has-margin-15-bottom'>
                        Use this guide to see where the planets are right now! Click below to learn more:
                    </div>
                    <ul>
                        {transits.map(this.renderTransit)}
                    </ul>
                </planet-tracker>
            );
        }

        return (<planet-tracker />);
    }

    renderTransit = ({ planet, sign, date_range }) => {
        let [from, to] = date_range.split(' – ');
        const href = `/astrology/planets/${planet}-in-${sign}`.toLowerCase();

        return (
            <li>
                <a
                    href={href}
                    onClick={() => this.props.trackEvent([
                        'Planet Tracker',
                        this.props.logged_in ? 'LI Click' : 'LO Click',
                        `${planet} in ${sign}`,
                    ])}
                >
                    {planet} in {sign}
                </a>
                <small>
                    {dayjs(from, 'MMM D, YYYY').format('M.D.YY')}
                    &nbsp;–&nbsp;
                    {dayjs(to, 'MMM D, YYYY').format('M.D.YY')}
                </small>
            </li>
        );
    }
}

const mapStateToProps = (state) => ({
    transits: state['planet-tracker'] && state['planet-tracker'].data && state['planet-tracker'].data.transits,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: () => dispatch({ type: 'planet-tracker:init' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
